export const imageURLList = [
	{
		url: "https://rb.gy/ezmy5q",
		alt: "Xbox one controller",
	},
	{
		url: "https://rb.gy/3k53d0",
		alt: "The insides of a computer",
	},
	{
		url: "https://rb.gy/rxvpmk",
		alt: "Arcade games",
	},
	{
		url: "https://rb.gy/agltka",
		alt: "Xbox one controller with yellow background",
	},
	{
		url: "https://rb.gy/k8aggf",
		alt: "Cat on computer",
	},
	{
		url: "https://rb.gy/cjmmhi",
		alt: "Custom keyboard",
	},
];
